import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import EmpSuccess from "../employees/employeeSuccess";
import { createNewRetailers, updateRetailers } from "../../../apis/retailers";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { assignManager, ChangeStatus, uploadFile } from "../../../apis/auth";
import {
  getAllNationalsFinancer,
  getAllNationalsRetailer,
} from "../../../apis/nationals";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
import Select from "react-select";
import { getAllEmployee } from "../../../apis/employees";

type PasswordField = "password" | "confirmPassword";

type RetailerResponse = {
  interest_active: boolean;
  employee_id: number;
  createdAt: string;
  full_name: string;
  address: string;
  geo_location: string;
  profile_pic: string;
  financer_id: number;
  email: string;
  phone_number: string;
  Status: string;
  id: any;
  company_name: string;
};

type RetailerData = {
  key: string;
  Image: string;
  Name: string;
  financer_id: string;
  Email: string;
  Phone: string;
  address: string;
  allDetails: any;
  Status: string;
  id: any;
  company_name: string;
  employee_id: number;
  interest_active?: boolean;
};
interface National {
  id: string;
  full_name: string;
}

const initialValues = {
  full_name: "",
  user_name: "",
  email: "",
  password: "",
  confirm_password: "",
  phone_number: "",
  prefix_code: "",
  company: "",
  about: "",
  geo_location: "",
  gst_no: "",
  company_name: "",
};

const addressState = {
  addressLine: "",
  city: "",
  states: "",
  country: "",
  pincode: "",
};

type EmployeeData = {
  value: number;
  key: number;
  EmpId: string;
  Name: string;
  Image: string;
  CurrentRole: string;
  Email: string;
  Phone: string;
  Designation: string;
  JoiningDate: string;
  Status: string;
  id: any;
  allData: any;
};

const ReatailersList = () => {
  const [address, setAddress] = useState(addressState);
  const [formData, setFormData] = useState(initialValues);

  const [plans, setPlans] = useState<any>();
  const [departFin, setDepartFin] = useState<any>([]);
  const [newStatus, setNewStatus] = useState<any>(null);
  const [isPermission, setIsPermission] = useState<any>(false);
  const [selectedOptions, setSelectedOptions] = useState<Record<number, any>>(
    {}
  );

  const [error, setError] = useState<string>("");
  const [imageUrl, setImageUrl] = useState<string>("");

  const [allRetailerData, setRetailerData] = useState<RetailerData[]>([]);
  const [filteredData, setFilteredData] = useState<RetailerData[]>([]);
  const [allEmployeesData, setEmployeesData] = useState<EmployeeData[]>([]);

  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [loader, setLoader] = useState(false);
  const [recordData, SetRecordData] = useState<any>();
  const [edit, setEdit] = useState(false);
  const [id, setId] = useState();

  const mtIdString = sessionStorage.getItem("info");
  const { city, states, country, pincode, addressLine } = address;
  let mtId: { id: string; user_id: string } | null = null;

  const userType = JSON.parse(mtIdString).type;
  const departNational = [{ value: "financer", label: "Financer" }];

  const getInitialSelectedOption = (record: RetailerData) => {
    const empId = record?.employee_id;
    if (!empId) return null;
    return allEmployeesData.find((emp) => emp.value === empId) || null;
  };

  const handleSelect = async (option: any | null, recordId: number) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [recordId]: option || undefined,
    }));

    if (option?.value) {
      await assignManager(recordId, { employee_id: option.value });
    }
  };

  const handleToggleInterestActive = async (
    retailerId: number | string,
    value: boolean
  ) => {
    try {
      await updateRetailers(retailerId, { interest_active: value });
      fetchAllRetailer();
    } catch (error) {
      console.error("Failed to update interest_active:", error);
    }
  };

  const {
    full_name,
    user_name,
    email,
    password,
    confirm_password,
    phone_number,
    gst_no,
    company_name,
  } = formData;

  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };

  const fetchAllRetailer = async () => {
    setLoader(true);
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllNationalsRetailer(data);
      const retailerData = response?.data?.retailerAllData?.map(
        (item: RetailerResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id || "--",
          CreatedAt: formatDate(item.createdAt),
          company_name: item.company_name,
          Name: `${item.full_name}` || "--",
          Email: item.email || "--",
          Phone: item.phone_number || "--",
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Image: item.profile_pic ? item.profile_pic : "--",
          Status: item.Status || "--",
          financer_id: item.financer_id || "--",
          employee_id: item.employee_id,
          interest_active: item.interest_active ?? false,
          allDetails: item,
        })
      );
      setRetailerData(retailerData || []);
      setFilteredData(retailerData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };

  const getAllFinancer = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsFinancer(data);
    const newResponse = response?.data?.financerAllData;
    setDepartFin(
      newResponse?.map((ele: National) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const [selectedNatOption, setSelectedNatOption] = useState<any>();

  const handleNatSelect = (option: any | null) => {
    setSelectedNatOption(option || undefined);
    setNewSelectedOption(undefined);
    setFinSelectedOption(undefined);
    getAllFinancer();
  };

  useEffect(() => {
    const fetchPlanData = sessionStorage.getItem("plan");
    if (fetchPlanData) {
      try {
        const parsedData = JSON.parse(fetchPlanData);
        const newParsedData = JSON.parse(parsedData[0]?.discription);
        setPlans(newParsedData);
      } catch (error) {
        console.error(error, "error");
      }
    } else {
      console.error("No plan data found");
    }
    fetchAllRetailer();
  }, [state]);

  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };

  const handleChangePermission = (data: { id: string; permission: string }) => {
    const payload = {
      id: data.id,
      permission: data.permission,
    };
    setNewStatus(payload);
    setIsPermission(true);
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Date",
      dataIndex: "address",
      render: (text: string, record: RetailerData) => (
        <div className="ms-2">
          {formatDate(record?.allDetails?.createdAt) || "--"}
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: RetailerData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md">
            <img
              src={`${record.Image}`}
              className="img-fluid rounded-circle"
              alt="Retailer"
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: RetailerData, b: RetailerData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: RetailerData, b: RetailerData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: RetailerData, b: RetailerData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: RetailerData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            {record?.allDetails?.financer?.company_name || "--"}
          </p>
        </div>
      ),
    },
    {
      title: "Interest Active",
      dataIndex: "interest_active",
      render: (_: any, record: RetailerData) => {
        const isActive =
          record.interest_active ?? record.allDetails?.interest_active ?? false;
        return (
          <div className="d-flex align-items-center">
            <button
              type="button"
              className={`btn btn-sm ${isActive ? "btn-success" : "btn-danger"}`}
              onClick={() =>
                handleToggleInterestActive(record.allDetails?.id ?? record.id, !isActive)
              }
            >
              {isActive ? "Enabled" : "Disabled"}
            </button>
          </div>
        );
      },
      sorter: (a: RetailerData, b: RetailerData) =>
        Number(!!a.interest_active) - Number(!!b.interest_active),
    },
    {
      title: "Manager Name",
      dataIndex: "managerName",
      width: 250,
      render: (text: string, record: RetailerData) => {
        const selected =
          selectedOptions[record.id] ?? getInitialSelectedOption(record);
        return (
          <div className="ms-3" onClick={() => setNewStatus(record)}>
            <Select
              classNamePrefix="react-select"
              className="select"
              options={allEmployeesData}
              value={selected}
              onChange={(option) => handleSelect(option, record.id)}
              placeholder="Select Employees"
            />
          </div>
        );
      },
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: RetailerData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{"Financer"}</p>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: RetailerData) => (
        (
          <span className="dropdown">
            <Link
              to="#"
              className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
                } d-inline-flex align-items-center badge-xs`}
              data-bs-toggle="dropdown"
            >
              <i className="ti ti-point-filled me-1" />
              {record?.allDetails?.user?.status || "N/A"}
            </Link>
            <ul className="dropdown-menu dropdown-menu-end p-3">
              <li>
                <div
                  className="dropdown-item rounded-1"
                  data-bs-toggle="modal"
                  data-bs-target="#status_modal"
                  onClick={() =>
                    handleChangeStatus({
                      id: record.allDetails.user_id,
                      status: "Active",
                    })
                  }
                >
                  Active
                </div>
              </li>
              <li>
                <div
                  className="dropdown-item rounded-1"
                  data-bs-toggle="modal"
                  data-bs-target="#status_modal"
                  onClick={() =>
                    handleChangeStatus({
                      id: record.allDetails.user_id,
                      status: "InActive",
                    })
                  }
                >
                  InActive
                </div>
              </li>
            </ul>
          </span>
        )
      ),
      sorter: (a: RetailerData, b: RetailerData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Approval Permissions",
      dataIndex: "actions",
      render: (text: string, record: RetailerData) => (
        <span className="dropdown">
          <Link
            to="#"
            className={`badge  btn btn-white ${text === "Active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            <p>{record?.allDetails?.user.permissions || "--"}</p>
          </Link>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangePermission({
                    id: record.allDetails.user_id,
                    permission: "Approved",
                  })
                }
              >
                Approved
              </div>
            </li>
            <li>
              <div
                className="dropdown-item rounded-1"
                data-bs-toggle="modal"
                data-bs-target="#status_modal"
                onClick={() =>
                  handleChangePermission({
                    id: record.allDetails.user_id,
                    permission: "UnApproved",
                  })
                }
              >
                Un-Approved
              </div>
            </li>
          </ul>
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: RetailerData) => (
        <div className="action-icon d-inline-flex">
          {userType === "master" && (
            <div
              style={{ cursor: "pointer" }}
              className="me-2"
              data-bs-toggle="modal"
              data-bs-target="#login_modal"
              onClick={() => login(record)}
            >
              <i className="fas fa-sign-in-alt" />
            </div>
          )}
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_retailer"
            onClick={() => handleEdit(record.allDetails)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to={`/viewRetailers?retailer_id=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
        </div>
      ),
    },
  ];

  const handleEdit = (data: any) => {
    setEdit(true);
    setId(data?.id);
    const parsedAddress = JSON.parse(data.address || {});
    setFormData((prevFormData) => ({
      ...prevFormData,
      full_name: data?.full_name,
      email: data?.email,
      phone_number: data?.phone_number,
      gst_no: data?.gst_number,
      company_name: data?.company_name,
    }));
    setAddress({
      addressLine: parsedAddress?.addressLine,
      city: parsedAddress?.city,
      states: parsedAddress?.states,
      country: parsedAddress?.country,
      pincode: parsedAddress?.pincode,
    });
  };

  const login = (data: any) => {
    SetRecordData(data);
  };
  const handleSubmitLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (mtIdString) {
      localStorage.setItem("info", mtIdString);
      let change = "change";
      sessionStorage.setItem("changing", change);
    }
    const payload = {
      id: recordData?.allDetails?.id,
      type: recordData?.allDetails?.type,
      user_id: recordData?.allDetails?.user_id,
      username: recordData?.allDetails?.full_name,
    };
    sessionStorage.setItem("info", JSON.stringify(payload));
    window.location.href = "/index";
  };

  const [newSelectedOption, setNewSelectedOption] = useState<any>();
  const [finSelectedOption, setFinSelectedOption] = useState<any>();

  const handleFinSelect = (option: any | null) => {
    setFinSelectedOption(option || undefined);
    const newResponse = allRetailerData.filter((ele, i) => {
      return Number(ele.financer_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }
  if (mtId && mtId.id) {
  }
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (password !== confirm_password) {
      errorAlert("password and confirm_password should be the same");
    }
    const requiredFields = [
      "email",
      "full_name",
      "password",
      "phone_number",
      "user_name",
    ];
    const editRequiredFields = ["email", "full_name", "phone_number"];
    const editedFields = edit ? editRequiredFields : requiredFields;
    const emptyFields = editedFields.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }
    setLoader(true);
    const master_Id = mtId?.id || "0";
    const payload = {
      address: address,
      email: formData.email,
      gst_number: formData.gst_no,
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      prefix_code: formData.company_name,
      user_name: formData.user_name,
      company_name: formData.company_name,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      financer_id: master_Id,
      type: "retailer",
    };

    try {
      if (!edit) {
        const response = await createNewRetailers(payload);
        if (response.status === true) {
          setSuccessCreation(true);
          setImage(null);
          setFormData(initialValues);
          setAddress(addressState);
          fetchAllRetailer();
        }
      } else {
        const payloads = {
          address: address,
          email: formData.email,
          gst_number: formData.gst_no,
          full_name: formData.full_name,
          phone_number: formData.phone_number,
          company_name: formData.company_name,
          profile_pic: imageUrl,
        };

        const response = await updateRetailers(id, payloads);
        if (response.status === true) {
          successAlert("success", "successfully updated ");
          setImage(null);
          setEdit(false);
          setId(null);
          setFormData(initialValues);
          setAddress(addressState);
          fetchAllRetailer();
        }
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allRetailerData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Retailer");
    XLSX.writeFile(workbook, "Retailers List.xlsx");
  };
  const handleSubmitStatus = async (event: any) => {
    event.preventDefault();
    try {
      let payload = {
        status: newStatus?.status,
      };
      if (isPermission) {
        const new_payload = {
          permissions: newStatus?.permission,
        };
        const response = await ChangeStatus(newStatus?.id, new_payload);
        if (response.status === true) {
          const message = isPermission
            ? `User Permission Changed to ${newStatus?.permission}`
            : `User Status Changed to ${newStatus?.status}`;

          successAlert("success", message);
          setIsPermission(false);
          setNewStatus(null);
          fetchAllRetailer();
        }
      } else {
        const response = await ChangeStatus(newStatus?.id, payload);
        if (response.status === true) {
          successAlert(
            "success",
            `User Status Changed to ${newStatus?.status}`
          );
          fetchAllRetailer();
          setNewStatus(null);
        }
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => { }, [isPermission]);

  const getAllEmployees = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllEmployee(data);
      const filteredEmployees = response.data.filter(
        (employee: any, i: any) => employee.type === "manager"
      );
      const employeeData = filteredEmployees?.map((item: any, i: number) => ({
        label: item.full_name ? item.full_name : "--",
        value: item.id || "--",
      }));
      setEmployeesData(employeeData);
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    getAllEmployees();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {plans && (
                <>
                  {typeof mtIdString === "string" &&
                    JSON.parse(mtIdString)?.type === "financer" &&
                    Number(plans?.total_retailer) > filteredData?.length && (
                      <div className="mb-2">
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-inert={true}
                          data-bs-target="#add_retailer"
                          className="btn btn-primary d-flex align-items-center"
                          onClick={() => {
                            setEdit(false);
                            setFormData(initialValues);
                            setAddress(addressState);
                            setImage(null);
                          }}
                        >
                          <i className="ti ti-circle-plus me-2" />
                          Create New Retailer
                        </Link>
                      </div>
                    )}
                </>
              )}

              {typeof mtIdString === "string" &&
                JSON.parse(mtIdString)?.type === "employee" && (
                  <div className="mb-2">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-inert={true}
                      data-bs-target="#add_retailer"
                      className="btn btn-primary d-flex align-items-center"
                      onClick={() => {
                        setEdit(false);
                        setFormData(initialValues);
                        setAddress(addressState);
                        setImage(null);
                      }}
                    >
                      <i className="ti ti-circle-plus me-2" />
                      Create New Retailer
                    </Link>
                  </div>
                )}
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allRetailerData={allRetailerData}
                    setFilteredData={setFilteredData}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedNatOption
                        ? selectedNatOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departNational?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {finSelectedOption
                        ? finSelectedOption.label
                        : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departFin.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleFinSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                ) : (
                  <p className="custom-cal-react " style={{ padding: "15px" }}>
                    No Data Found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_retailer">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Retailer</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>

                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                {image ? "Replace" : "Upload"}
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="full_name"
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="phone_number"
                            value={phone_number}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Company Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="company_name"
                            value={company_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {!edit && (
                        <>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                user_name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="user_name"
                                value={user_name}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Password <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.password
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  name="password"
                                  value={password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.password
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 ">
                              <label className="form-label">
                                Confirm Password{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  name="confirm_password"
                                  value={confirm_password}
                                  onChange={handleChange}
                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Gst No <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="gst_no"
                            value={gst_no}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address Line <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="addressLine"
                            value={addressLine}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="city"
                            value={city}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="states"
                            value={states}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="country"
                            value={country}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            PinCode <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="pincode"
                            value={pincode}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="login_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Login</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitLogin}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to login</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Login{" "}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default ReatailersList;
